// Module
var code = "<svg viewBox=\"0 0 515.556 515.556\" xmlns=\"http://www.w3.org/2000/svg\">\r\n  <path d=\"M257.778 128.885l257.778 257.778H386.67L257.778 257.774 128.892 386.671 0 386.663z\"/>\r\n</svg>\r\n";
// Exports
module.exports = code;